export default __webpack_public_path__ + "static/media/facebookWhite.10d343c2.svg";